module.exports = __webpack_public_path__ + "static/media/imagem13.80b622e7.jpeg";